import { Pipe, type PipeTransform } from '@angular/core';
import { Translation } from 'src/app/models/translation';

enum ExternalState {
  Open = 0,
  BeingProcessed = 1,
  Rejected = 2,
  Closed = 3,
}

@Pipe({
  name: 'externalState',
  standalone: false,
})
export class ExternalStatePipe implements PipeTransform {

  public translation: Translation = JSON.parse(localStorage.getItem('Translation'));

  transform(value: number): string {
    switch (value) {
      case ExternalState.Open: return this.translation.ExternalStateOpen;
      case ExternalState.BeingProcessed: return this.translation.ExternalStateBeingProcessed;
      case ExternalState.Rejected: return this.translation.ExternalStateRejected;
      case ExternalState.Closed: return this.translation.ExternalStateClosed;
    };
  }
}